import vue from 'vue'
import {apolloClient} from '@/graphql/apolloWrapper'
import {GET_SITEINI_LIST} from "../../graphql/queries/siteini/list";
import {GET_SITEINI_ENCRYPTED_LIST} from "../../graphql/queries/siteini/listEncrypted";
import {GET_SITEINI_LIST_BY_LICENSE} from "../../graphql/queries/siteini/listByLicense";
import {GET_SITEINI_COUNTRIES} from "../../graphql/queries/siteini/countries";
import {SITEINI_KEY_UPDATE} from "../../graphql/mutations/siteini/updateKey";
import {SITEINI_OPERATION_MOVE} from "../../graphql/mutations/siteini_operation/move";
import {SITEINI_OPERATION_COOKIES} from "../../graphql/mutations/siteini_operation/cookies";

const state = {
  siteiniCountries: [],
  siteinis: []
};

const getters = {
  getSiteiniCountries: (state) => state.siteiniCountries,
  getSiteiniByCountry: (state) => (country) => state.siteinis.filter(siteini => siteini.country === country),
  getSiteiniByLicense: (state) => (licenseId) => state.siteinis.filter(siteini => siteini.license_id === licenseId),
  getSiteiniEncrypted: (state) => state.siteinis.filter(siteini => siteini.encrypted === true),
};

const mutations = {
  UPDATE_SITEINI_COUNTRY_LIST (state, countries) {
    state.siteiniCountries = countries;
  },
  UPDATE_SITEINI_LIST (state, siteinis) {
    siteinis.forEach(siteini => {
      state.siteinis.upsert({id: siteini.id}, siteini)
    })
  },
  UPDATE_SITEINI_LICENSE_LIST (state, {licenseId, siteinis}) {
    vue.set(state.siteiniByLicense, licenseId, siteinis);
  },
  INCREMENT_SITEINI_USED_COUNT (state, {siteini, count}) {
    let siteiniIndex = state.siteinis.findIndex(siteiniEntry => siteiniEntry.site === siteini)
    if (siteiniIndex >= 0) {
      let siteiniEntry = state.siteinis[siteiniIndex];
      vue.set(state.siteinis[siteiniIndex], 'channelUsedCount', siteiniEntry.channelUsedCount + count)
    }
  },
  UPDATE_SITEINI_COUNTRY (state, siteini) {
    const id = siteini.id;
    const country = siteini.country;
    if (id && country) {
      const siteiniEntry = state.siteinis.find(siteini => siteini.id === id);
      siteiniEntry.country = country;
    }
  },
  UPDATE_SITEINI_COOKIES (state, siteini) {
    const id = siteini.id;
    const cookies = siteini.cookies;
    if (id && cookies) {
      const siteiniEntry = state.siteinis.find(siteini => siteini.id === id);
      siteiniEntry.cookies = cookies;
    }
  }
};

const actions = {
  async siteiniFetchCountryList ({commit, state}) {
    if (!state.siteiniCountries.length) {
      const {data} = await apolloClient.query({query: GET_SITEINI_COUNTRIES});
      if (data && data.siteiniCountryList) {
        commit('UPDATE_SITEINI_COUNTRY_LIST', data.siteiniCountryList);
      }
    }
  },
  async siteiniFetchList ({commit, state}, country) {
    // if (!state.siteinisByCountry || !state.siteinisByCountry[country]) {
    const {data} = await apolloClient.query({query: GET_SITEINI_LIST, variables: {'country': country}});

    if (data && data.siteiniList) {
      commit('UPDATE_SITEINI_LIST', data.siteiniList);
    }
    // }
  },
  async siteiniFetchListByLicense ({commit}, licenseId) {
    const {data} = await apolloClient.query({query: GET_SITEINI_LIST_BY_LICENSE, variables: {'licenseId': licenseId}});

    if (data && data.siteiniListByLicense) {
      commit('UPDATE_SITEINI_LIST', data.siteiniListByLicense);
    }
  },
  async siteiniFetchEncryptedList ({commit}) {
    const {data} = await apolloClient.query({query: GET_SITEINI_ENCRYPTED_LIST});

    if (data && data.siteiniList) {
      commit('UPDATE_SITEINI_LIST', data.siteiniList);
    }
  },
  async siteiniDecryptKeyUpdate ({commit, dispatch}, input) {
    const {data} = await apolloClient.mutate({mutation: SITEINI_KEY_UPDATE, variables: {id: input.id, key: input.key}});

    if (data && data.siteiniDecryptKeyUpdate) {
      commit('UPDATE_SITEINI_LIST', [data.siteiniDecryptKeyUpdate]);
      dispatch('setSuccessMessages', 'Decrypt Key was updated successfuly');
    }
  },
  async siteiniOperationMove ({commit, dispatch}, input) {
    const {data} = await apolloClient.mutate({mutation: SITEINI_OPERATION_MOVE, variables: {input}});

    if (data && data.siteiniOperationCreateMove) {
      const site = data.siteiniOperationCreateMove.site;
      const country = data.siteiniOperationCreateMove.country;
      if (site && country) {
        commit('UPDATE_SITEINI_COUNTRY', data.siteiniOperationCreateMove);
        dispatch('setSuccessMessages', `Successfuly moved site.ini "${site}" to country "${country}" `);
      }
    }
  },
  async siteiniOperationCookie ({commit, dispatch}, input) {
    const {data} = await apolloClient.mutate({mutation: SITEINI_OPERATION_COOKIES, variables: {input}});

    if (data && data.siteiniOperationCreateCookie) {
      const site = data.siteiniOperationCreateCookie.site;
      if (site) {
        commit('UPDATE_SITEINI_COOKIES', data.siteiniOperationCreateCookie);
        dispatch('setSuccessMessages', `Successfuly updated cookies for site.ini "${site}"`);
      }
    }
  },
  // {subject: id, cookies: cookies}
};

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/siteini.js